// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var Spinner = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M9.393 24.893a2.29 2.29 0 0 1-2.286 2.286 2.3 2.3 0 0 1-2.286-2.286 2.29 2.29 0 0 1 2.286-2.286 2.28 2.28 0 0 1 2.286 2.286m8.893 3.678c0 1.268-1.018 2.286-2.286 2.286s-2.286-1.018-2.286-2.286 1.018-2.286 2.286-2.286 2.286 1.018 2.286 2.286M5.714 16c0 1.268-1.018 2.286-2.286 2.286S1.142 17.268 1.142 16s1.018-2.286 2.286-2.286S5.714 14.732 5.714 16m21.465 8.893a2.3 2.3 0 0 1-2.286 2.286 2.29 2.29 0 0 1-2.286-2.286 2.28 2.28 0 0 1 2.286-2.286 2.29 2.29 0 0 1 2.286 2.286M9.964 7.107c0 1.571-1.286 2.857-2.857 2.857S4.25 8.678 4.25 7.107 5.536 4.25 7.107 4.25s2.857 1.286 2.857 2.857M30.857 16c0 1.268-1.018 2.286-2.286 2.286S26.285 17.268 26.285 16s1.018-2.286 2.286-2.286 2.286 1.018 2.286 2.286M19.429 3.429a3.43 3.43 0 0 1-6.858 0 3.43 3.43 0 0 1 6.858 0m9.464 3.678c0 2.214-1.804 4-4 4-2.214 0-4-1.786-4-4 0-2.196 1.786-4 4-4 2.196 0 4 1.804 4 4"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(Spinner);
export default ForwardRef;
